export default "__VITE_ASSET__C10LI6SZ__"